import React from 'react';
import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import { formatDateTime } from '@hud/web-components/utils';
import { EntitiesPopover } from '../../../components/EntitiesPopover/EntitiesPopover';
import { Container } from '@hud/web-components/Container/Container';
import { MessageQueue } from '@hud/portal-dtos/webapp-message-queue.dto';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';
import { useFiltersForFunction } from '../../../hooks/useFiltersForFunction';
import { formatFlowType } from '../../../utils';

export interface MessageQueueOverviewProps {
  queue?: MessageQueue;
  loading: boolean;
  referralBreadcrumbs?: BreadcrumbItem[] | undefined;
  tags?: Record<string, string> ;
}

export default function MessageQueueOverview({
  queue,
  loading,
  referralBreadcrumbs,
  tags,
}: MessageQueueOverviewProps) {
  const filtersForFunction = useFiltersForFunction(
    queue?.id,
    queue?.services,
    tags,
  );
  return (
    <Container variant="filled" title="Details" icon="webviewMenu.info" width='100%'>
      <DataColumns.WrappableColumns>
        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="Type">
            {formatFlowType(queue?.type)}
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Polling method">
            Each{' '}
            {
              queue?.queuePullingType === 'MESSAGE' ? 'Message'
              : queue?.queuePullingType === 'BATCH' ? 'Batch'
              : ''
            }
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Service">
            {queue?.services ? (
              <EntitiesPopover
                entityType="services"
                entities={queue.services}
              />
            ) : null}
          </DataColumns.Row>
        </DataColumns.Column>
        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="Last tracked invocation">
            {queue?.lastSeenAt
              ? formatDateTime(queue.lastSeenAt, true)
              : '-'}
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Processing function">
            {queue?.processingFunction ? (
              <EntitiesPopover
                entityType="functions"
                entities={[queue.processingFunction]}
                referralBreadcrumbs={referralBreadcrumbs}
                filtersForLink={filtersForFunction}
              />
            ) : null}
          </DataColumns.Row>
        </DataColumns.Column>
      </DataColumns.WrappableColumns>
    </Container>
  );
}
